//PrimeReact
import { Dialog } from "primereact/dialog"

//ReferralEntity components
import ReferralEntityForm from "./ReferralEntityForm"

export default function ReferralEntityFormDialog({
  showDialog,
  onHideDialog,
  referralPartnerId,
  showChangeRequests,
  onProfileUpdated,
  onSelectPartner,
}) {
  return (
    <Dialog
      header={
        !!referralPartnerId
          ? "Manage partner profile"
          : "Create new partner profile"
      }
      visible={showDialog}
      onHide={() => {
        onHideDialog()
      }}
      style={{ width: "1100px", height: "900px" }}
    >
      <ReferralEntityForm
        hideHeader
        onCancelClick={onHideDialog}
        onEntityCreated={(value) => {
          if (!!value?.select) {
            onSelectPartner(value.entityId)
          } else {
            onProfileUpdated(value)
          }
        }}
        referralEntityId={referralPartnerId}
        showChangeRequests={showChangeRequests}
      />
    </Dialog>
  )
}
